'use strict';

import objectMap from './objectMap';
import objectSlider from './objectSlider';
import objectOptions from './objectOptions';
import objectTable from './objectTable';

export default function objectView () {
    objectMap();

    objectSlider();

    objectOptions();

    objectTable();
}
